import {
  SET_WALLET_CONFIG,
  SET_WALLET_CONFIG_ERR,
  CLEAR_WALLET_CONFIG,
} from "../actions/wallet";

export default function walletConfig(
  config = {},
  { type, newConfig = null, error = null }
) {
  switch (type) {
    case SET_WALLET_CONFIG: {
      return { config: newConfig, error: null };
    }
    case SET_WALLET_CONFIG_ERR: {
      return { config: null, error };
    }
    case CLEAR_WALLET_CONFIG:
      return {};
    default:
      return config;
  }
}
